export const isTablet = () => window.matchMedia('(max-width: 992px)').matches;
